import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './brandCard.css';

/* BrandCard — one brand tile (`.bb-card`).
   The React port of SP-main's `SF.brandCard`. See brandCard.css for the four
   things deliberately not on this tile.

   It is an <a>, not a clickable div: the whole tile is the target, and a
   wrapping div with onClick is not keyboard reachable, announces nothing and
   cannot be opened in a new tab. `onClick` only lets a router intercept, and
   still gets the event so it can `preventDefault`. */
export default function BrandCard({ name, logo, href, onClick, color, initials }) {
  const [broken, setBroken] = useState(false);

  /* Initials are the fallback when there is no logo file or it 404s — the
     reference keeps `--bc` on the card for exactly this. */
  const fallback = initials
    || String(name || '')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase();

  return (
    <a
      className="bb-card"
      href={href}
      aria-label={name}
      onClick={onClick}
      style={color ? { '--bc': color } : undefined}
    >
      <span className="bb-logo">
        {logo && !broken
          ? <img src={logo} alt="" loading="lazy" onError={() => setBroken(true)} />
          : <span className="bb-initials">{fallback}</span>}
      </span>
      <span className="bb-name" title={name}>{name}</span>
    </a>
  );
}

BrandCard.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  /** Fallback tint for a brand with no logo file — the reference's `--bc`. */
  color: PropTypes.string,
  /** Override the derived initials. */
  initials: PropTypes.string,
};
